const CalenderIcon = ({ h, w }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6.00065 0.666016V1.99935H10.0007V0.666016H11.334V1.99935H14.0007C14.3689 1.99935 14.6673 2.29783 14.6673 2.66602V13.3327C14.6673 13.7009 14.3689 13.9993 14.0007 13.9993H2.00065C1.63246 13.9993 1.33398 13.7009 1.33398 13.3327V2.66602C1.33398 2.29783 1.63246 1.99935 2.00065 1.99935H4.66732V0.666016H6.00065ZM13.334 7.33268H2.66732V12.666H13.334V7.33268ZM7.33398 8.66602V11.3327H4.00065V8.66602H7.33398ZM4.66732 3.33268H2.66732V5.99935H13.334V3.33268H11.334V4.66602H10.0007V3.33268H6.00065V4.66602H4.66732V3.33268Z" fill="#333333" />
        </svg>

    )
}
export default CalenderIcon